import {createSlice} from '@reduxjs/toolkit'
import {UserModel} from '../../features/auth/models'

export const EmptyUserState: UserModel = {
  id: '',
  changePassword: false,
  apellidoMaterno: '',
  apellidoPaterno: '',
  cambioContrasena: false,
  tokenPassword: '',
  error: false,
  rol: '',
  usuario: '',
  razonSocial: '',
  nombres: '',
  message: '',
  perfilId: '',
  token: '',
  lstAplicaciones: [],
  lstPerfil: [],
  lstSites: [],
  applicationId: '',
  versionAplicacion: ''
}

export const userSlice = createSlice({
  name: 'user',
  initialState: EmptyUserState,
  reducers: {
    loginUser: (state, action) => {
      return {...state, ...action.payload}
    },

    setUser: (state, action) => {
      return {...state, ...action.payload}
    },
    logoutUser: () => {
      return EmptyUserState
    },
    resetUser: () => {
      return EmptyUserState
    },
    setApplicationId: (state, action) => {
      state.applicationId = action.payload
    },
  },
})

export const {loginUser, logoutUser, resetUser, setUser, setApplicationId} = userSlice.actions

export default userSlice.reducer
